import React, { useCallback, useState } from "react";
import { Checkbox, Flex, AgGridReact, AgGrid } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { type PayeeType } from "#graphql/supergraphTypes";

const PAYEE_TYPE_OPTIONS: { value: PayeeType; label: string }[] = [
  { value: "vendor", label: "Vendor" },
  { value: "entity", label: "Entity" },
  { value: "investment", label: "Investment" },
];

export const PayeeTypeFilter = (filterParams: AgGridReact.CustomFilterProps) => {
  const { onModelChange, getValue } = filterParams;
  const [selectedTypes, setSelectedTypes] = useState<PayeeType[]>(
    (filterParams.model as PayeeType[] | null) ?? [],
  );

  const toggleType = useCallback(
    (value: PayeeType) => {
      setSelectedTypes((prev) => {
        const exists = prev.includes(value);
        const next = exists ? prev.filter((type) => type !== value) : [...prev, value];

        onModelChange(next.length > 0 ? next : null);

        return next;
      });
    },
    [onModelChange],
  );

  const doesFilterPass = useCallback(
    (params: AgGrid.IDoesFilterPassParams) => {
      if (!selectedTypes.length) {
        return true;
      }

      const nodeValue = getValue(params.node) as PayeeType | undefined;

      if (!nodeValue) {
        return false;
      }

      return selectedTypes.includes(nodeValue);
    },
    [getValue, selectedTypes],
  );

  AgGridReact.useGridFilter({ doesFilterPass });

  return (
    <Flex
      data-testid="payee-type-filter"
      flexDirection="column"
      gap={Sizes.XS}
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {PAYEE_TYPE_OPTIONS.map((option) => (
        <Checkbox
          key={option.value}
          label={option.label}
          checked={selectedTypes.includes(option.value)}
          onChange={() => toggleType(option.value)}
        />
      ))}
    </Flex>
  );
};
